import axios from 'axios'
import Cookies from 'js-cookie'

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('afr-portale-authorization-token')
    config.url = process.env.REACT_APP_API_DOMAIN + process.env.REACT_APP_API_ENDPOINT + config.url
    config.headers = {
      Authorization: `${token}`,
      Accept: 'application/json',
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  (error) => {
    console.log('ERROR-----', error)
    // Handle network errors and other errors here.
    // The error parameter contains the error details.

    // Do something based on the error status code or other criteria.
    if (error.response) {
      // The server responded with a status code outside the range of 2xx.
      // You can access the status code
      if(error.response.status === 401 || error.response.status === 403){
        
        localStorage.removeItem('afr-portale-authorization-token')
        window.location = '/login'
        return Promise.reject(refreshError)
      }
     
    }else if(error?.code === 'ERR_NETWORK'){
      // Cookies.remove('afr-portale-authorization-token')
      // window.location = '/login'
      return
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)

export default axios
